import { useQuery } from "react-query"
import { useMainContext } from "../../../modules/Dashboard"
import { filterFetch, normalFetch } from "../../../core/services/fetch-api/get"

export const useGetAllTickers = (filter) => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['tickers-list'],
        () => normalFetch(token, `market/predict/tickers?search=${filter.search}&query=${filter.query}`),
        {
            select: (res) => res?.data?.data,
            refetchOnWindowFocus: false,

        }
    )
}

export const useGetAllAssistant = () => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['assistants-list'],
        () => normalFetch(token, `market/predict/assistants`),
        {
            select: (res) => res?.data?.data,
            refetchOnWindowFocus: false,

        }
    )
}

export const useGetTickerDetails = ({ requestId, responseType, enabled }) => {
    const { profile: { token } } = useMainContext()

    return useQuery(
        'ticker-details', () => normalFetch(token, `market/predict/${requestId}?responseType=${responseType}`), //
        {
            select: res => res?.data?.data,
            enabled: !!enabled,
            refetchOnWindowFocus: false
        }
    )
}

export const useGetTickerDetailsForce = ({ ticker, responseType, assistant, frame, enabled, }) => {

    const { profile: { token } } = useMainContext()

    return useQuery(
        'ticker-details-force', () => normalFetch(token, `market/predict/force?ticker=${ticker}&frame=${frame}&responseType=${responseType}&assistant=${assistant}`), //
        {
            select: res => res?.data?.data,
            enabled: !!ticker && !!enabled,
            refetchOnWindowFocus: false
        }
    )
}

export const useGetPredictHistory = (filter) => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['predict-history'],
        () => filterFetch(filter, token, `market/requests`),
        {
            // refetchInterval: 5000,
            select: (res) => res?.data,
            refetchOnWindowFocus: false,
        }
    )
}

export const useGetAssistantCategories = () => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['assistant-category'],
        () => normalFetch(token, `settings/category`),
        {
            select: (res) => res?.data?.data,
        }
    )
}